import React from 'react';

const Hero = ({ image, title, tagLine }) => <section className='relative mt-5 h-fit pt-8'>


    {/* <figure className='w-full md:h-[55dvh]'>
        <img src={image} className="w-full h-full object-cover" />
    </figure> */}

    {/* <div className='bg-myBlue md:bg-black/80 md:absolute inset-x-0 md:top-1/2 md:-translate-y-1/2 text-white text-center py-10 md:py-14'> */}

    {/* <h1 className='text-myYellow text-2xl md:text-5xl mb-2'>{title}</h1> */}
    <div className='px-4 md:px-8' >
        <h1 className='text-black text-2xl md:text-4xl font-semibold mb-2' >{title}</h1>

        {tagLine && <p className='font-bold'>{tagLine}</p>}

    </div>

</section>

export default Hero